<script>
import { mapGetters } from 'vuex'
import { orderBy } from 'lodash'
import EmptyStateBlock from '@components/general/empty-state-block.vue'

export default {
  components: { EmptyStateBlock },
  computed: {
    ...mapGetters({
      generalFiles: 'auth/getGeneralFiles',
    }),
    sortedFileList() {
      if (!this.generalFiles || this.generalFiles.length === 0) return []
      return orderBy(this.generalFiles, 'fileName')
    },
  },
  methods: {
    downloadGeneralFile(file) {
      this.$emit('downloadGeneralFile', file)
    },
    notLastListItem(index) {
      return index < this.generalFiles.length - 1
    },
  },
}
</script>

<template>
  <article>
    <v-list
      v-if="sortedFileList.length > 0"
      dense
      class="my-0 py-0"
      width="350"
    >
      <template v-for="(file, index) in sortedFileList">
        <v-list-item
          :key="`general-file-li-${file.fileName}-${index}`"
          style="height: 56px"
          class="general-file"
          link
          :title="$t('layout.generalFilesListDownloadIconTooltip')"
          @click="downloadGeneralFile(file)"
        >
          <v-list-item-title v-text="file.fileName"></v-list-item-title>

          <v-list-item-action>
            <v-icon color="grey lighten-1">mdi-download</v-icon>
          </v-list-item-action>
        </v-list-item>

        <v-divider
          v-if="notLastListItem(index)"
          :key="`general-file-divider-${file.fileName}-${index}`"
        ></v-divider>
      </template>
    </v-list>
    <EmptyStateBlock
      v-else
      border
      icon="mdi-file"
      :title="$t('error.noFilesAvailableEmptyStateTitle')"
    />
  </article>
</template>
